import React from 'react'
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import clsx from 'clsx'

export default (props) => {
  const {
    state,
    classes,
    toggleDialogs,
    hendleDeleteSubgroup,
    DELETE_SUB_GROUP_DIALOG,
  } = props
  const mobileClasses = useMobileStyle()

  return (
    <ResponsiveDialog
      isFullScreen={false}
      className={clsx(
        classes.groupDialog,
        mobileClasses.lessPaddingMobile,
        'deleteSubgroupModal',
      )}
      open={state.isOpenDeleteSubGroupDialog}
    >
      <DialogTitle className={classes.groupDeleteTitle}>
        <FormattedMessage id="group.details.dialogs.deleteSubgroup" />
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {state.deleteMsg}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            toggleDialogs(DELETE_SUB_GROUP_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <DeleteButton
          onClick={hendleDeleteSubgroup}
          className={mobileClasses.modalBtn}
        />
      </DialogActions>
    </ResponsiveDialog>
  )
}
